import { createFileRoute } from "@tanstack/react-router";

import { LiveScenarioTreeCanvas } from "@/components/canvas/live-scenario-tree-canvas";

export const Route = createFileRoute("/$workspace/scenario-tree")({
  head: () => ({ meta: [{ title: "Scenario Tree — Dravian Horizon" }] }),
  component: ScenarioTreePage,
});

function ScenarioTreePage() {
  const { workspace } = Route.useParams();
  return <LiveScenarioTreeCanvas workspaceId={workspace} />;
}
